/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'

/**
 * Typescript enum
 */

export enum TeachingTableCtaTag {
  buySeat = 'buySeat',
  enrolled = 'enrolled',
  hidden = 'hidden',
  joinTable = 'joinTable',
  viewRoster = 'viewRoster'
}

/**
 * TeachingTableCtaTag
 *
 * Teaching table CTA Tag
 */
export const TeachingTableCtaTagEnumType = types.enumeration('TeachingTableCtaTag', [
  'buySeat',
  'enrolled',
  'hidden',
  'joinTable',
  'viewRoster'
])
